// src/modules/app-views/offers/pages/Init/components/tableColumns/typeColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function typeColumn(buildColumnProps, options = {}) {
  const {
    key = 'type',
    title = 'type',
    dataIndex = 'type',
    width = 140,
    align = 'left',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const typeUid = r?.type;
      if (!typeUid) return '—';

      // Resolve type name from parameters
      const types = appService.getModulePreferences({ category: 'types' }) || [];
      const found = types.find(t => t.uid === typeUid && !t.removed);
      return found?.name || typeUid;
    },
  };
}

export default typeColumn;
